import { get, includes } from 'lodash';
import aws from '../utils/aws';
import _ from 'lodash';

export function createAction(actionTypeOrCreator, params, context) {
    if (typeof actionTypeOrCreator === 'function') {
        return actionTypeOrCreator(params, context);
    } else {
        return {
            type: actionTypeOrCreator
        };
    }
}

export function processResponse(response) {
    const type = response.headers.get('content-type');

    if (includes(type, 'application/json')) {
        return response.json()
            .catch(() => (undefined));
    } else if (!response.ok) {
        throw new Error('Something went wrong');
    } else {
        return response.text()
            .catch(() => (undefined));
    }
}

export function verifyResult(result) {
    if (result && result.error) {
        const message = get(result, 'message', 'Error');
        throw new Error(message);
    }
}

export const countsPerAction = {};

const fetchMiddleware = ({
    dispatch
}) => (next) => async (action) => {
    const {
        failureActionTypeOrCreator,
        fetchParams,
        loadActionTypeOrCreator,
        successActionTypeOrCreator
    } = action;

    if (successActionTypeOrCreator) {
        let runCount;
        let loadAction;
        if (loadActionTypeOrCreator) {
            loadAction = createAction(loadActionTypeOrCreator);
            countsPerAction[loadAction.type] = countsPerAction[loadAction.type] ? countsPerAction[loadAction.type] + 1 : 1;
            runCount = countsPerAction[loadAction.type];
            dispatch(loadAction);
        }

        try {
            const base64Auth = get(fetchParams, 'headers.Authorization');

            let userTokens = {};
            if (!action.forceSkipTokenMiddleware) {
                userTokens =  await aws.getCurrentUserTokens(base64Auth);

                if (_.get(fetchParams, 'options.addRefreshToken')) {
                    fetchParams.body = { refreshToken: userTokens.refreshToken };
                }
            }

            const response = await aws.invokeApi(fetchParams, userTokens.idToken);
            const result = await processResponse(response);

            verifyResult(result);
            if (runCount === countsPerAction[loadAction?.type] || !!fetchParams.shouldAllowConcurrentFetches) {
                dispatch(createAction(successActionTypeOrCreator, result, action.successActionContext));
            }
        } catch (error) {
            console.error(error);

            const dispatchedError = {
                message: error.message
            };
            dispatch(createAction(failureActionTypeOrCreator, dispatchedError));
        }
    } else {
        next(action);
    }
};

export default fetchMiddleware;
